import { useEffect } from "react";
import { useState } from 'react';

//import { UseAuth } from './StAuthGiver';


const WhichEnv = (process.env.REACT_APP_TURBO_ENV === undefined?'aws':'staging');
const Tdebug = (WhichEnv != 'aws');

export const getApiServer = () => {
    if (WhichEnv === 'aws') {
        return 'https://api-us.turbosteed.com';
    }
    else {
        return `https://${process.env.REACT_APP_HOST_URL}`;
    }   
}

export class CustomError extends Error {
  
    constructor(message, errJson) {
      super(message);
      this.errJson = errJson;
      this.name = this.constructor.name;
    }
}

export class ApiRc {

    constructor() {
        //super();
    }

}

export const callApi = async (url, reqMethod, moreHeaders, reqBody, sendBodyFlag = true) => {

    //const {loginAction, logOut} = UseAuth();

    const acctSid = localStorage.getItem('turbosteedAcct');
    const act_e = localStorage.getItem('act_e');

    console.log("callApi: sBF: " + sendBodyFlag);

    if ((acctSid == undefined) || (acctSid == '') ||
        (act_e == undefined) || (act_e == '')) {

            return null;
    }

    const maxExecCnt = 2;
    let execCnt = 0;

    let apiRc = {
        disposition: 'retry',     // abort, retry, change, logout, empty, resourceExists
        message: '',              // Sent by the server.
        respBody: {},             // Sent by the server.
        httpStatus: '100',        // Sent by the server.
        loginHook: ''             // Store the cookies.

    };


        try {

            const acctSid = localStorage.getItem('turbosteedAcct');
            const act_e = localStorage.getItem('act_e');
        
            console.log("callApi: acctSid: " + acctSid);
            console.log("callApi: acctSid: " + act_e);
        
            if ((acctSid == undefined) || (acctSid == '') ||
                (act_e == undefined) || (act_e == '')) {
        
                    return null;
            }

            const sendBody = ((reqMethod !== 'GET') && (reqMethod !== 'HEAD') && (reqMethod !== 'DELETE'))
            
            let fetchConfig = {
                method: reqMethod,
                withCredentials: true,
                credentials: 'include', // Browser will send the cookies along with the request. (include => for CORS)
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(acctSid + ':' + act_e)
                }
            };

            if (sendBody) {
                fetchConfig.body = reqBody;
            }

            console.log(fetchConfig);

            const baseUrl = getApiServer() + '/users/' + acctSid;
                
            const response = await fetch(baseUrl + url, fetchConfig)
            /*{
                method: method,
            
                withCredentials: 'true',     
                credentials: 'include',   // Browser will send the cookies along with the request. (include => for CORS)
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(acctSid + ':' + act_e)
                }, 
                (sendBody == true? (body: reqBody) : '')
            })*/.then((response) => {
                console.log("In response");
                console.log(response);
                console.log(response.headers);
                console.log(response.data);
                console.log(JSON.stringify(response));
                console.log("In response");

                if (response.ok == false) {

                    const httpStatus = response.status;
                    return response.json().then((err) => {
                        Tdebug && console.log(err);
                        Tdebug && console.log(err.message);     // This is the actual message.
                        Tdebug && console.log(httpStatus);      // This is the status code.
                        throw new CustomError(err.message, {    // CustomError works.
                            httpCode: httpStatus,
                            messageBody: err || ''
                        });
                    })
                }
                
                return response.json();
            }).then((responseJson) => {
                console.log(responseJson);

                // Account SID cannot change, hence, only check for
                // the new token.
                
                if (responseJson.etac !== undefined) {

                    //let encAuth = responseJson.etac;
                    //loginAction(null, encAuth);
                    //apiRc.loginHook = responseJson.etac;
                }
                else {
                    // Some error, logout the user.
                    //apiRc.disposition = 'logout';
                    //apiRc.httpStatus = '200';
                    //return apiRc;
                }


                apiRc = {
                    disposition: 'success',                // abort, retry, change, logout, empty, resourceExists, success
                    message: responseJson.message || '',   // Sent by the server.
                    respBody: responseJson || {},          // Sent by the server.
                    httpStatus: '200'                      // Sent by the server.
                };
                
            }).catch((error) => {
                console.log(JSON.stringify(error));
                console.log("Will not take action!");

                Tdebug && console.log(JSON.stringify(error));
                Tdebug && console.log(error);
                Tdebug && console.log(error.errJson.httpCode);     // This works.
                Tdebug && console.log(error.errJson.messageBody);  // This works.

                switch (error.errJson.httpCode)
                {
                    case 401:
                        apiRc = {
                            disposition: 'logout',                              // abort, retry, change, logout, empty, resourceExists
                            message: error.errJson.messageBody.message || '',   // Sent by the server.
                            respBody: error.errJson.messageBody || {},                 // Sent by the server.
                            httpStatus: error.errJson.httpCode                  // Sent by the server.
                        };
                        break;

                    case 405:
                    case 410:
                    case 409:
                    case 400:
                        // Cannot be recovered unless code is changed.    
                        apiRc = {
                            disposition: 'change',                              // abort, retry, change, logout, empty, resourceExists
                            message: error.errJson.messageBody.message || '',   // Sent by the server.
                            respBody: error.errJson.messageBody  || {},         // Sent by the server.
                            httpStatus: error.errJson.httpCode,                 // Sent by the server.
                    
                        };

                        break;

                    case 410:
                        // Cannot be recovered unless code is changed.   
                         
                        apiRc = {
                            disposition: 'resourceExists',                      // abort, retry, change, logout, empty, resourceExists
                            message: error.errJson.messageBody.message || '',   // Sent by the server.
                            respBody: error.errJson.messageBody || {},         // Sent by the server.
                            httpStatus: error.errJson.httpCode,                 // Sent by the server.

                        };
                        break;

 

                    case 404:
                        // Not found.
                        console.log("In not found switch case");
                        apiRc = {
                            disposition: 'empty',                               // abort, retry, change, logout, empty, resourceExists
                            message: error.errJson.messageBody.message || '',   // Sent by the server.
                            respBody: error.errJson.messageBody || {},      // Sent by the server.           
                            httpStatus: error.errJson.httpCode,                 // Sent by the server.
                    
                        };
                        break;
                    
                    case 500:
                    case 502:
                    default:
                    
                        // Retry:
                        apiRc = {
                            disposition: 'retry',                               // abort, retry, change, logout, empty, resourceExists
                            message: error.errJson.messageBody.message || '',   // Sent by the server.
                            respBody: error.errJson.messagBody || {},         // Sent by the server.
                            httpStatus: error.errJson.httpCode,                 // Sent by the server.
                    
                        };

                        break;
                }
            });
        } catch (fetchErr) {
            Tdebug && console.log(fetchErr);

            apiRc = {
                disposition: 'retry',       // abort, retry, change, logout, empty, resourceExists
                message: 'network error',   
                respBody: {},               
                httpStatus: 500,            
            };
        }

        return apiRc;

}

export const getCurSiteId = () => {
    const curSiteIdx = localStorage.getItem('curSiteIdx');
    let currentSites = JSON.parse(localStorage.getItem("sites"));

    Tdebug && console.log(curSiteIdx);
    Tdebug && console.log(currentSites);

    // currentSites is an arrary of JSON {siteId, siteName}
    // Hence, get the siteId from this array.
    const siteId = currentSites?.[curSiteIdx]["siteId"];

    return siteId;
}

// Get the utm and other tracking data.
export const getTrackingData = () => {

	// tracking data cookie = tdc
	const match = document.cookie.match(/tdc=([^;]+)/);
	const state = match ? JSON.parse(decodeURIComponent(match[1])) : null;

	console.log("getTrackingData: state is: " + state);
	console.log("getTrackingData: state is: " + JSON.stringify(state));

	return state;
}




//export default callApi;
